export const breakpoints = {
    // min-width
    largeDesktop: 1920,
    desktop: 1680,
    laptop: 1280,
    tablet: 744,
    smallTablet: 640,
    mobile: 320,
};
